import { DateTime } from "luxon";

// Create Journal from Photos: when a place's event ends. Ends when the next
// place's first photo was taken if that's later the same day; otherwise (the
// next photo is on another day, or this is the trip's last place) a default
// visit length. Using the next photo's time regardless made the last stop of
// each day "end" the next day (shown as "14:45 – 13:14") and the trip's last
// stop last zero minutes (2026-10-24). The schedule stays a starting point.
// Identical in andiamo-web and andiamo-places.
export const JOURNAL_DEFAULT_VISIT_MINUTES = 60;

export const journalEventEnd = (startMillis, nextStartMillis) => {
  const start = DateTime.fromMillis(startMillis);
  if (nextStartMillis != null && nextStartMillis > startMillis) {
    const next = DateTime.fromMillis(nextStartMillis);
    if (next.hasSame(start, "day")) return next;
  }
  return start.plus({ minutes: JOURNAL_DEFAULT_VISIT_MINUTES });
};
